import AboutUsBanner from "./AboutUs-Banner/AboutUsBanner";
import Information from "./Information/Information";
import Information2 from "./Information2/Information2";

import Staff from "../Staff/Staff";
import Contact from "../Contact/Contact";
import Project from "../Project/Project";
import History from "../History/History";
import Vision from "../Vision/Vision";
import Commits from "../Commit/Commit";
import part_pc from "../../assets/images/part_pc.webp";
import part_mo from "../../assets/images/part_mo.webp";
export default function AboutUS() {
  return (
    <div className=" w-full ">
      <AboutUsBanner />
      <Information />
      <div className="w-full bg-center bg-cover bg-no-repeat lg:py-10 bg-[url('./assets/images/part_mo.webp')] md:bg-[url('./assets/images/part_pc.webp')]">
        <History />
        <Vision />
      </div>

      <div>
        <Information2 />
        <div className="w-full bg-[#f8ffff]">
          <Staff />
        </div>

        <Project />
        <Commits />
        <Contact />
      </div>
    </div>
  );
}
